<template>
  <div class="dashboard_right absolute">
    <!-- 按钮蒙层 -->
    <div v-if="!equip_data.is_iot_ready" class="overlay">
      <button
        type="button"
        class="btn btn-info waves-effect waves-light"
      >
        <span>{{ $t("建议进行IOT升级") }}</span>
      </button>
    </div>
    <div style="height: 100%">
      <!-- 整站面板 -->
      <div class="dashboard-panel">
        <div
        v-if="equip_data.is_iot_ready"
          class="electric"
          :style="`${
            topIndex.length > 1 ? 'border-right: 1px solid #fff;' : ''
          }`"
        >
          <label>{{
            topIndex.length
              ? chartlist[topIndex[0]] && chartlist[topIndex[0]].name
              : ""
          }}</label>
          <div class="cont">
            <span class="value" v-if="equip_data.is_iot_ready">{{
              topIndex.length
                ? chartlist[topIndex[0]] && chartlist[topIndex[0]].v
                : ""
            }}</span>
            <span class="unit">{{
              topIndex.length
                ? chartlist[topIndex[0]] && chartlist[topIndex[0]].unit
                : ""
            }}</span>
          </div>
        </div>
        
        <div v-if="equip_data.is_iot_ready" class="pressure">
          <label>{{
            topIndex.length
              ? chartlist[topIndex[1]] && chartlist[topIndex[1]].name
              : ""
          }}</label>
          <div class="cont">
            <span class="value" v-if="equip_data.is_iot_ready">{{
              topIndex.length
                ? chartlist[topIndex[1]] && chartlist[topIndex[1]].v
                : ""
            }}</span>
            <span class="unit">{{
              topIndex.length
                ? chartlist[topIndex[1]] && chartlist[topIndex[1]].unit
                : ""
            }}</span>
          </div>
        </div>
      </div>

      <div class="right_contain" style="height: calc(100% - 102px)">
        <div class="d-flex align-items-center">
          <p
            style="
              border-radius: 1.25rem 1.25rem 0 0;
              background-color: rgba(0, 0, 0, 0.5);
            "
            class="w-100 p-2 m-0 d-flex align-items-center"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ $t("Customise_Dashboard") }}<i class="ri-arrow-down-s-line"> </i>
          </p>

          <div
            class="dropdown-menu dropdown-menu-end dropdown_box"
            aria-labelledby="dropdownMenuClickableInside"
            style="
              width: 430px;
              color: #fff;
              z-index: 1;
              padding: 10px 0px;
              border-radius: 1.25rem;
              background: linear-gradient(
                152deg,
                rgba(49, 46, 46, 0.4) 0%,
                rgba(69, 68, 65, 0.4) 100%
              );
              box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
              border-top: 0.0625rem solid #b6b7bc3f;
              border-left: 0.0625rem solid #b6b7bc3f;
              border-right: 0.0625rem solid #b6b7bc3f;
              height: 350px;
            "
          >
            <div class="h-100 w-100">
              <div>
                <p class="mb-0" style="font-size: 16px; margin-left: 20px">
                  {{ $t("overview_static.device_page.add_more_data") }}
                </p>
                <img src="./icon-divider.svg" alt="" />
              </div>
              <div
                id="cockpitTree"
                data-simplebar
                data-simplebar-auto-hide="false"
                style="
                  overflow: auto;
                  width: 100%;
                  height: calc(100% - 60px);
                  max-height: calc(100% - 60px);
                "
              >
                <cockpitTreeStar
                  v-model:dataList="selectCheckedList"
                  @saveInstancesSetting="saveInstancesSetting"
                  @changeStarStat="changeStarStat"
                  :topIndex="topIndex"
                  :chartIndex="chartIndex"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="children"
          :style="{ height: equip_data.name === 'NEV2 070' ? '50%' : '95%' }"
        >
          <!-- 公共title -->
    <Top :name="name" :show-button="false"></Top>
          <ShockData
            :equip_data="equip_data"
            :chartlist="chartlist"
            :chartIndex="chartIndex"
          ></ShockData>
        </div>
        <div class="children status" v-if="false">
          <Status></Status>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Select from "../Select";
import AMapLoader from "@amap/amap-jsapi-loader";

import ShockData from "./component/ShockData.vue";
import Status from "./component/Status.vue";
import moment from "moment";
// import { valueFormatter } from "../../utils/common.js";
import cockpitTreeStar from "@/components/cockpitTreeStar.vue";
// import _ from "loadsh";
export default {
  props: ["isShowEcharts", "equip_data", "chartlist", "equip_data_info_list"],
  emits: ["topIndexEvent"],
  data() {
    return {
      retryCount: 0,
      dataList: [],
      topIndex: [] /* 置顶展示两个测点信息 */,
      chartData: [],
      chartIndex: [] /* echarts展示情况 */,
      electricName: "功率",
      pressureName: "出口压力",
      option_show: false,
      ImageList: {
        dropdown: require("@/assets/icon-font/icon-dropdown.svg"),
      },
      defaultProps: { children: "children", label: "name" },
      electric: 35.01,
      pressure: -94,
      currentChecked: "data",
      timer: null,
    };
  },
  computed: {
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    name() {
      return this.$t("Unit Real-time Operation Data");
    },
    numView() {
      return this.$route.query.index || 1;
    },
    selectCheckedList() {
      var list = [];
      list.push(this.equip_data);
      // var su
      // this.recursionArr(list).forEach(i=>{
      //   console.log(this.topIndex,"this.topIndexthis.topIndexthis.topIndex");
      //   if(i.attributes&&i.attributes.measurements){
      //       i.attributes.measurements.forEach((item,index)=>{
      //         if(this.topIndex[0]==index || this.topIndex[1]==index ){ //默认展示电流，电压
      //           item.isShow = true
      //         }else{
      //           item.isShow = false
      //         }
      //       })
      //     }
      // })
      return this.recursionArr(list);
    },
    selectChecked() {
      let selectData = [];
      if (window.localStorage.getItem("selectChecked")) {
        selectData = JSON.parse(window.localStorage.getItem("selectChecked"));
      } else {
        selectData = [
          { name: "振动数据", checked: true, disabled: false },
          {
            name: "状态",
            checked: true,
            disabled: false,
          },
        ];
      }
      window.localStorage.setItem("selectChecked", JSON.stringify(selectData));
      return selectData;
    },
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        let locale = JSON.parse(window.localStorage.getItem("selectChecked"));
        if (val == "en") {
          locale.map((item) => {
            switch (item.name) {
              case "生产节拍":
                item.name = this.$t("Takt_Time");
                break;
              case "人均分析":
                item.name = this.$t("Values_Per_Capita");
                break;
              case "今日废品分析":
                item.name = this.$t("Daily_Defects_Status");
                break;
              case "本月废品分析":
                item.name = this.$t("Monthly_Defects_Status");
                break;
            }
          });
          window.localStorage.setItem("selectChecked", JSON.stringify(locale));
        } else {
          locale.map((item) => {
            switch (item.name) {
              case "Cycle Time":
                item.name = "生产节拍";
                break;
              case "Values Per Capita":
                item.name = "人均分析";
                break;
              case "Daily Defects Status":
                item.name = "今日废品分析";
                break;
              case "Monthly Defects Status":
                item.name = "本月废品分析";
                break;
            }
          });
          window.localStorage.setItem("selectChecked", JSON.stringify(locale));
        }
      },
      deep: true,
    },
    // chartlist:{
    //   handler(newVal) {
    //     if(newVal){
      
    //     }
    //   },
    //   deep: true,

    // }
  },
  unmounted() {
    clearInterval(this.timer);
  },
  mounted() {
    // this.getMapToken();
   this.$nextTick(() => {
    this.chartIndex=[]
    this.topIndex=[]
    let length = this.chartlist.length,
      a = 0,
      b = 0;

    if (length > 2 || length == 2) {
      this.chartlist.map((item, index) => {
        if(this.isPaperMaking){
          
          if (item.equipment_id==this.equip_data.id&&item.name==="总脱水量") {
            a += 1; //只添加一次
            if (a == 1) this.topIndex.push(index);
          }
          if (item.equipment_id==this.equip_data.id&&item.name==="透平机真空度") {
            console.log(item,"单体1");
            b += 1; //只添加一次
            if (b == 1) this.topIndex.push(index);
          }
        }else{
          if (item.name==="电流") {
            a += 1; //只添加一次
            if (a == 1) this.topIndex.push(index);
          }
          if (item.name==="压力") {
            b += 1; //只添加一次
            if (b == 1) this.topIndex.push(index);
          }
        }
      });
      if (this.topIndex.length == 1) {
        this.chartlist.map((it, ind) => {
          if (it && !(ind == this.topIndex[0])) {
            //排除掉找到默认状态的一个
            this.topIndex.push(ind);
            return;
          }
        });
      } else if (this.topIndex.length == 0) {
        this.topIndex = [0, 1];
      }
    } else if (length == 1) {
      this.topIndex = [0];
    } else {
      this.topIndex = [];
    }
    this.$emit("topIndexEvent", this.topIndex);
    /* 设备测点折线图：默认状态下排除2个top状态*/
    this.equip_data.attributes &&
      this.equip_data.attributes.measurements.forEach((item, index) => {
        if(index<5){
          item.is_checked = true;
        }
        if (this.topIndex[0] == index || this.topIndex[1] == index) {
            item.is_checked = false;
          }

        if (item.is_checked) {
          this.chartIndex.push(item.id);
        }
      });


   })
    // this.chartData = _.cloneDeep(this.chartlist)

    /* 设备默认状态下2个top状态 */
    

    // this.timer = setInterval(() => {
    //   if(this.$route.query.index==1){
    //     this.pressure = this.randoms(-94, -98);
    //     this.electric = this.randoms(35.01, 36.5);
    //     this.electricName = '机组运行电流'
    //     this.pressureName = '机组吸气压力'
    //   }else if(this.$route.query.index==2){
    //     this.pressure = this.randoms(9, 10);
    //     this.electric = this.randoms(35.01, 36.5);
    //     this.electricName = '机组运行电流'
    //     this.pressureName = '机组吸气压力'
    //   }else{
    //     this.pressure = this.randoms(700, 950);
    //     this.electric = this.randoms(170, 202);
    //     this.electricName = '功率'
    //     this.pressureName = '出口压力'
    //   }

    // }, 1000);
    // console.log(this.topIndex,this.chartlist,"top展示：单体");
    
  },
  methods: {
    
    getMapToken() {
      console.log(1);
      // let config = {
      //         headers: {
      //           "Content-Type": "application/json",
      //           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      //         },
      //         withCredentials: true,
      //       };
      //       axios
      //         .get(
      //           this.ruluka_host +
      //             "/api/v1/"+deviceToken+"/attributes?clientKeys=Latitude,Longitude",
      //           config
      //         )
      //         .then((ress) => {
      //           console.log(ress.data.client,deviceToken);
      //           AMapLoader.reset(); //在加载地图前加一个reset方法 解决报错
      //           this.initMap(ress.data.client); //加载地图
      //         });
      this.initMap({
        Longitude: "118.43534807255436",
        Latitude: "35.34961212737784",
      });
    },
    async initMap(client) {
      await AMapLoader.load({
        key: "	d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("mapBoxs", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 13, //初始化地图级别
            center: [client.Longitude, client.Latitude], //初始化地图中心点位置
            mapStyle: "amap://styles/darkblue", //地图的显示样式
          });
          const marker = new AMap.Marker({
            //新增一个标记点
            position: [client.Longitude, client.Latitude],
            icon: new window.AMap.Icon({
              // image: 'https://vdata.amap.com/icons/b18/1/2.png', // 自定义图标地址
              size: new window.AMap.Size(30, 40), // 图标大小
            }),
          });
          marker.setMap(this.map);
        })
        .catch((e) => {
          console.log(e);
        });
      // await AMapLoader.load({

      //   key: "d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
      //   callback: "onAPILoaded", //回调函数
      // });

      // this.map = new window.AMap.Map("mapBox", {
      //   //生成底图在mapContainer这个div里
      //   center: [client.Longitude, client.Latitude], // 初始中心点坐标
      //   zoom: 17, // 初始缩放级别
      // });
      // this.map.setMapStyle("amap://styles/darkblue");
      // // this.addMarker(client); //添加标记点的方法
    },
    addMarker(client) {
      console.log(this.map);
      this.map.setMapStyle("amap://styles/darkblue");

      this.marker = new window.AMap.Marker({
        //新增一个标记点
        position: [client.Longitude, client.Latitude],
        icon: new window.AMap.Icon({
          // image: 'https://vdata.amap.com/icons/b18/1/2.png', // 自定义图标地址
          size: new window.AMap.Size(30, 40), // 图标大小
        }),
      });
      this.marker.setMap(this.map); //放在map这个对象里面
      //顺便新增一个点击标记点出来的窗口
      this.infoWindow = new window.AMap.InfoWindow({
        //新增一个window窗口
        width: 200,
        content: "奥体中心", // 添加你想要显示的文字描述
        offset: new window.AMap.Pixel(0, -30), // 设置信息窗体偏移量，使其显示在标记点正上方
      });

      // 点击标记点时显示信息窗体
      // this.infoWindow.open(this.map, this.marker.getPosition());

      // this.marker.on("click", () => {
      //   this.infoWindow.open(this.map, this.marker.getPosition());
      // });
    },
    /** 回调函数 地图渲染好时触发 不需要可以删掉 */
    onAPILoaded() {
      this.loaded = true;
      console.log("执行对地图的其他操作");
      // 在这里可以执行其他与地图相关的操作
    },
    moment,
    /* 默认展示数据发生改变*/
    changeChartData(index, list) {
      index.forEach((item) => {
        this.chartData.push(list[item]);
      });
    },
    /* 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页面 */
    toServcePage() {
      this.$router.push({
        path: "/repair-request/add",
        query: { id: this.equip_data.customer_id, sn: this.equip_data.root_sn },
      });
    },
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = true;
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }

      return result.filter((item) => {
        return item.num == 1;
      });
    },
    chooseInput(type) {
      this.currentChecked = type;
      this.selectCheckedList.forEach((select) => {
        if (type == select.type) {
          select.checked = true;
        } else {
          select.checked = false;
        }
      });
      //   this.toggleChecked();
    },
    toggleChecked() {
      this.option_show = !this.option_show;
    },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    },
      /* 勾选状态 */
      saveInstancesSetting(data) {
      /* 遍历出投选状态下测点索引数组 */
      this.chartIndex = this.chartIndex.filter((item) => {
        return data.indexs.indexOf(item) == -1;
      })
      if(data.index_id.length>0){
        this.chartIndex= this.chartIndex.concat(data.index_id)
      }
      this.chartIndex =[...new Set(this.chartIndex)] ;
      console.log( data,this.chartIndex )

    },
    /* 置顶选项 */
    changeStarStat(list) {
      let reslut = [];
      list.map((item, index) => {
        if (item.isShow) {
          reslut.push(index);
        }
      });
      this.topIndex = reslut;
      this.$emit("topIndexEvent", this.topIndex);
    },
  },
  components: {
    // Select,
    ShockData,
    Status,
    cockpitTreeStar,
  },
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");
.right_select {
  .poninterNone {
    pointer-events: none;
  }
  .select_icon {
    width: 16px;
    background-size: cover;
    background-repeat: no-repeat;
    &.rotate {
      transform: rotate(180deg);
    }
  }
  .select_column {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 10px 20px;

    &:hover {
      cursor: pointer;
    }
  }
  .select_option {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    box-sizing: border-box;
    z-index: 8;
    position: absolute;
    top: 100%;
    right: 100%;
    .option {
      padding: 10px 30px;
      &:nth-of-type(1) {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
      }
      &:hover {
        cursor: pointer;
        background-color: #062323;
      }
    }
    .option_name {
      margin-left: 10px;
    }
  }
  .select_btn {
    font-weight: 700;
    padding: 8px;
    text-align: center;
    border-top: 2px solid #212121;
    color: #1cc9cb;
    &:hover {
      cursor: pointer;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.8s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
.dashboard_right {
  // position: relative; //用于蒙层
  width: 400px;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: column;
  .right_contain {
    flex: 1;
    .children {
      width: 100%;
      height: 95%;
      padding: 20px 20px 10px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 0 0 10px 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      &:nth-of-type(2n) {
        margin-bottom: 0px;
      }
      &.status {
        height: auto;
      }
    }
  }

  .dashboard-panel {
    min-height: 92px;
    display: flex;
    padding: 5px 0;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    margin-bottom: 10px;
    .electric,
    .pressure {
      flex: 1;
      padding: 10px 20px;
      box-sizing: border-box;
      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        color: #00e7ff;
      }
      label {
        font-size: 16px;
      }
      .value,
      .unit {
        font-size: 20px;
      }
    }
  }
}
.dropdown_box {
  right: 405px !important;
  top: -40px !important;
}
//蒙层盒子 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页
.overlay {
  position: absolute;
  top: 2px;
    left: 0px;
    width: 100%;
    height: 100%;
  background-color: rgba(285, 286, 288, 0.6); /* 半透明黑色 */
  z-index: 1;
  // cursor: pointer; /* 可选：为蒙层添加鼠标指针样式 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
</style>
